<script setup>
import StaticWidget from "@/components/common/other/StaticWidget";
import StaticTooltip from "@/components/common/other/StaticTooltip";

import {useCreateSubstringText} from "@/composables/common/useCreateSubstringText";

import {inject} from 'vue'

const shipments = inject("shipments");

</script>

<template class="cmp-view-shipment-from-to">
  <div id="Vue-3-component-view-shipment-from-to" class="cmp-view-shipment-from-to_wrapper">
    <div class="cmp-view-shipment-from-to_container">
      <div class="cmp-view-shipment-from-to_heading">From
        <div class="cmp-view-shipment-from-to_icon"><i class="fa-sharp fa-regular fa-warehouse-full"></i></div>

      </div>
      <div class="cmp-view-shipment-from-to_text-box-area">
        <div class="cmp-view-shipment-from-to_outer-color-box">
          <div class="cmp-view-shipment-from-to_inner-box">
            <div class="cmp-view-shipment-from-to_inner-heading">Shipper Name:</div>
          </div>
          <div class="cmp-view-shipment-from-to_inner-box">
            <StaticTooltip :icon="false">
              <template #content>
                {{ shipments.viewShipment.shipperName || 'No Data' }}
              </template>
              <div class="cmp-view-shipment-from-to_shipper-data" :class="!shipments.viewShipment.shipperName ?
               'global-no-data-placeholder' : ''">
                {{ useCreateSubstringText(shipments.viewShipment.shipperName, 60) || 'Shipper Name....' }}</div>
            </StaticTooltip>
          </div>
        </div>
        <div class="cmp-view-shipment-from-to_outer-color-box">
          <div class="cmp-view-shipment-from-to_inner-box">
            <div class="cmp-view-shipment-from-to_inner-heading">Origin:</div>
          </div>
          <div class="cmp-view-shipment-from-to_inner-box">
            <StaticTooltip :icon="false">
              <template #content>
                {{ shipments.viewShipment.shipperOrigin || 'No Data' }}
              </template>
              <div class="cmp-view-shipment-from-to_shipper-data" :class="!shipments.viewShipment.shipperOrigin ?
               'global-no-data-placeholder' : ''">
                {{  useCreateSubstringText(shipments.viewShipment.shipperOrigin, 60) || 'Origin....' }}
              </div>
            </StaticTooltip>
          </div>
        </div>
      </div>
    </div>
    <div class="cmp-view-shipment-from-to_container">
      <div class="cmp-view-shipment-from-to_heading">To
        <div class="cmp-view-shipment-from-to_icon cmp-view-shipment-from-to_to-icon">
          <i class="fa-sharp fa-solid fa-flag-checkered"></i>
        </div>
      </div>
      <div class="cmp-view-shipment-from-to_text-box-area">
        <div class="cmp-view-shipment-from-to_outer-color-box">
          <div class="cmp-view-shipment-from-to_inner-box">
            <div class="cmp-view-shipment-from-to_inner-heading">Consignee Name:</div>
          </div>
          <div class="cmp-view-shipment-from-to_inner-box">
            <StaticTooltip :icon="false">
              <template #content>
                {{ shipments.viewShipment.consigneeName || 'No Data' }}
              </template>
              <div class="cmp-view-shipment-from-to_shipper-data" :class="!shipments.viewShipment.consigneeName ?
              'global-no-data-placeholder' : ''">
                {{useCreateSubstringText(shipments.viewShipment.consigneeName, 60) || 'Consignee Name....' }}</div>
            </StaticTooltip>
          </div>
        </div>
        <div class="cmp-view-shipment-from-to_outer-color-box">
          <div class="cmp-view-shipment-from-to_inner-box">
            <div class="cmp-view-shipment-from-to_inner-heading">Destination:</div>
          </div>
          <div class="cmp-view-shipment-from-to_inner-box">
            <StaticTooltip :icon="false">
              <template #content>
                {{ shipments.viewShipment.consigneeDestination || 'No Data' }}
              </template>
              <div class="cmp-view-shipment-from-to_shipper-data" :class="!shipments.viewShipment.consigneeDestination ?
              'global-no-data-placeholder' : ''">
                {{  useCreateSubstringText(shipments.viewShipment.consigneeDestination, 60) || 'Consignee Destination....' }}</div>
            </StaticTooltip>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<style lang="scss" scoped>

.cmp-view-shipment-from-to {

  &_wrapper {
    display: flex;
    gap: 10px;
  }

  &_container {
    display: flex;
    width: 100%;
    height: 110px;
    border: 1px solid #e2e2e2;
    border-radius: var(--rounded-corners);
    padding: 10px;
    gap: 60px;
    border-left: 6px solid var(--left-border-highlight)
  }

  &_heading {
    position: relative;
    width: 100px;
    font-size: 14px;
    font-weight: bold;
  }

  &_icon {
    font-size: 60px;
    margin-left: 40px;
    color: #091c7e;
    opacity: 0.2;
  }

  &_to-icon {
    color: #1e5f2d;
  }

  &_text-box-area {
    width: 80%;
  }

  &_outer-color-box {
    display: flex;
    align-items: center;
    height: 50px;
    border-radius: 4px;
    background: #eceff1;
    margin-bottom: 10px;
    padding-left: 8px;
    gap: 20px;
  }

  &_inner-box {
    display: flex;
    align-items: center;
    height: 28px;
    width: auto;
    background: white;
    margin: 4px;
    font-size: 13px;
    font-weight: bold;
    padding: 0 20px 0 10px;
    border-radius: 4px;
  }

  &_inner-heading {
    width: 110px;
  }

  &_shipper-data {
    width: 480px;
    font-weight: normal;
  }

  @media screen and (max-width: 1440px) {
    &_shipper-data {
      width: max-content;

    }

  }
}





</style>
